import React from 'react'
import {MainContainer} from './ui/command-center-layout'
import {Header, Icon} from '@thryvlabs/maverick'
import SkeletonLoader from './skeleton-loader'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {AccountInfoBanner} from './account-info-banner'

function CommandCenterLayout({
  children,
  title,
  prevStep,
  centeredHeader,
  columnAmount,
  isLoading,
  showBackButton = false,
  accountInfo,
}) {
  const {frontendCatalogBackButton} = useFlags()
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <SkeletonLoader height="50vh" width="79vw" />
      </div>
    )
  }
  return (
    <MainContainer columnAmount={columnAmount}>
      <div>
        {accountInfo && (
          <AccountInfoBanner
            thryvId={accountInfo.thryvID}
            companyName={accountInfo.recurlyCompany}
            firstName={accountInfo.recurlyFirst}
            lastName={accountInfo.recurlyLast}
            billTo={
              accountInfo.billTo ||
              accountInfo.billingMode ||
              accountInfo.bill_to
            }
            style={{marginBottom: '16px'}}
          />
        )}
        {!frontendCatalogBackButton && (
          <Icon
            type="solid"
            variant="arrowLeft"
            className="back__arrow mb-2"
            onClick={prevStep}
          />
        )}
      </div>
      {title && (
        <div className={centeredHeader && 'centered-header'}>
          <Header fontWeight="normal" variant="h1">
            {title}
          </Header>
        </div>
      )}
      {children}
    </MainContainer>
  )
}

export {CommandCenterLayout}
